/** Converts a buffer to a data URI */
export const toDataUri = (buffer, mimeType) => `data:${mimeType};base64,${btoa(unescape(encodeURIComponent(buffer)))}`
